import React from "react";
import axios from "axios";

const SubscriptionPlans = () => {
  const plans = [
    { title: "Basic", price: 19, description: "For individuals just starting out.", amount: 1 },
    { title: "Pro", price: 49, description: "For serious property seekers.", amount: 1 },
    { title: "Enterprise", price: 99, description: "For professionals and investors.", amount: 1 },
  ];

  const handlePayment = async (plan) => {
    try {
      const { data } = await axios.post("http://127.0.0.1:8000/create-order", {
        amount: plan.amount,
      });

      const options = {
        key: "rzp_test_Gpj7KOsWASfff4",
        amount: data.amount,
        currency: data.currency,
        name: "Real Estate Subscriptions",
        description: `${plan.title} Plan`,
        order_id: data.id,
        handler: function (response) {
          alert("Payment successful! Payment ID: " + response.razorpay_payment_id);
        },
        prefill: { name: "Your Name", email: "test@example.com", contact: "9876543210" },
        theme: { color: "#3399cc" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <section className="container my-5">
      <h2 className="text-center mb-5">Choose Your Subscription Plan</h2>
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {plans.map((plan, index) => (
          <div className="col" key={index}>
            <div className="card h-100 text-center shadow-sm">
              <div className="card-body">
                <h5 className="card-title">{plan.title}</h5>
                <h6 className="text-success">₹{plan.price}</h6>
                <p>{plan.description}</p>
                <button className="btn btn-primary w-100" onClick={() => handlePayment(plan)}>
                  Choose Plan
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SubscriptionPlans;
